import Box from '@mui/material/Box';
import { ReactNode } from 'react';
import { MAX_WIDTH } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';

interface Props {
  children: ReactNode | ReactNode[];
  noPadding?: boolean;
  fullWidth?: boolean;
}

export const FormFieldsWrapper = ({
  children,
  noPadding = false,
  fullWidth = false
}: Props) => {
  return (
    <Box
      flexDirection="column"
      display="flex"
      gap={2.5}
      pt={noPadding ? 0 : 3}
      width={fullWidth ? '100%' : 'auto'}
      maxWidth={fullWidth ? 'none' : MAX_WIDTH}
    >
      {children}
    </Box>
  );
};
